import moment from 'moment-timezone';
import { Badge } from 'react-bootstrap';

export const TRAP_CATCH_COLOUR = '#00008B';
export const EGG_COLOUR = '#FFA500';

export const GDD_COLOUR = '#00008B';
export const RAINFALL_COLOUR = '#FFA500';

export const GDD_THRESHOLD = 650;

export const HIGH_RISK = '#d70909';
export const MEDIUM_RISK = '#e4e400';
export const LOW_RISK = '#009700';

export const formatDate = (date) =>
  date ? moment(date).format('DD-MMM') : 'N/A';

export const formatDateNz = (date) =>
  moment(date).tz('Pacific/Auckland').format('DD-MMM');

export const HpawResultBadge = ({ result }) => {
  if (result === 'low') {
    return <Badge variant='secondary'>Low</Badge>;
  } else if (result === 'high') {
    return <Badge variant='primary'>High</Badge>;
  }
  return null;
};

export const QcResultBadge = ({ result }) => {
  if (result === 'pass') {
    return <Badge variant='success'>Pass</Badge>;
  } else if (result === 'fail') {
    return <Badge variant='danger'>Fail</Badge>;
  }
  return null;
};